export default {
  error: {
    applicant: {
      address1st: '',
      address2nd: null, // 任意入力項目は入力チェックOK状態に設定する
      deliveryAt: '',
      email: '',
      nameKana: '',
      name: '',
      postCode: '',
      prefecture: '',
      remarks: null,
      tel: '',
    },
    delivery: {
      address1st: null,
      address2nd: null, // 任意入力項目は入力チェックOK状態に設定する
      name: null,
      nameKana: null,
      postCode: null,
      prefecture: null,
      tel: null,
    },
    payment: {
      payAt: null,
      payBy: null, // 初期表示するため入力チェックOK状態に設定する
    },
  },
};
